export default {
  // navigation
  dashboard: "Dashboard",
  smartvault: "SmartVault",
  orders: "Orders",
  reports: "Reports",
  analytics: "Analytics",
  brandStories: "Brand Stories",
  passports: "Passports",
  users: "Users",
  companies: "Companies",
  ordersImport: "Orders Import",
  settings: "Settings",
  roles_permissions: "Roles & Permissions",
  logout: "Sign out",

  // general
  loading: "Loading...",
  no_data: "No data",
  date: "Date",
  last_saved: "Last saved",
  comment: "Comment",
  photos: "Photos",
  position: "Position",
  recently_added: "Recently Added",
  city: "City",
  country: "Country",

  // actions
  actions: "Actions",
  save: "Save",
  send: "Send",
  cancel: "Cancel",
  view: "View",
  edit: "Edit",
  delete: "Delete",
  download: "Download",
  please_select: "Please select",
  back: "Back",
  back_to_search: "Back to Search",
  close: "Close",

  // company type
  manufacturer: "Manufacturer",
  client: "Client",
  clients: "Clients",

  // status
  draft: "Draft",
  sent: "Sent",

  // search
  search: "Search",
  advanced_search: "Advanced Search",
  browse_by: "Browse By",
  all_resources: "All resources",
  select_client: "Select client",
  select_client_first: "Select a client first",
  showing_x_results: "Showing {current} of {total}",
  showing_results_from_to_total:
    "Showing results from {from} to {to} (Total {totalRows})",
  results_filtered: "Results are filtered",
  clear_all: "Clear all",

  // create & update
  created_at: "Created at",
  updated_on: "Updated on",
  last_modified_by: "Last Modified by",
  created_ago: "Created {timeago}",
  last_modified_ago: "Last modified {timeago}",

  // errors
  something_went_wrong: "Something went wrong!",
  queue_error:
    "An error {error} occurred while processing your request. Don’t worry, the queue is still processing."
};
